<template>
  <div class="ml-3 mt-3" style="width:970px">
	<div class="mb-2">
            <el-form inline ref="form" :model="searchform">
        
       

                    <el-form-item  class="mb-0">
                         <el-date-picker
                              v-model="searchform.time"
                               range-separator="~"
                              :start-placeholder="$t('searchText.시작')"
                              type="daterange"
                              size="mini" class="mr-2" value-format="yyyy-MM-dd" style="width:200px;">
                            </el-date-picker>
                    </el-form-item>
                    <el-form-item class="mb-0">
                        <el-button type="info" size="mini" @click="searchEvent">{{$t('searchText.검색')}}</el-button>  
                    </el-form-item>
            </el-form>
       
         
        
            
            
        </div>
	

  <el-table
      :data="tableData"
       v-loading="loading"
      style="width: 100%"
       class="mt-2"  :empty-text="$t('tableText.데이타가없습니다')" >
    
    
     
             <el-table-column
           align="center"
            prop="bet_id"
            label="아이디">
            
          </el-table-column>

          <el-table-column
           align="center"
            prop="slot"
            label="슬롯베팅">
             <template slot-scope="scope">{{ formatMoney(scope.row.slot)}}</template>
          </el-table-column>
            <el-table-column
           align="center"
            prop="casino"
            label="카지노베팅">
             <template slot-scope="scope">{{ formatMoney(scope.row.casino)}}</template>
          </el-table-column>
            <el-table-column
           align="center"
            prop="slotrog"
            label="슬롯롤링">
             <template slot-scope="scope">{{ formatMoney(scope.row.slotrog)}}</template>
          </el-table-column>
            <el-table-column
           align="center"
            prop="casinorog"
            label="카지노롤링">
             <template slot-scope="scope">{{ formatMoney(scope.row.casinorog)}}</template>
          </el-table-column>

         
    
     
     <!--  <el-table-column
			prop="contents"
             :label="$t('msg.내용')">
			 <template slot-scope="scope">
            	<el-input
					  type="textarea"
					  :rows="2"
					  v-model="scope.row.contents">
					</el-input>
        	</template>
		  </el-table-column> -->
		  
		  
		 


	
		  
	
		 
    </el-table>
     <div style="height: 100px;"></div>
                     <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 0px;right: 0;z-index: 100;"> 
				  <div style="flex: 1;" class="px-2">
					  <el-pagination
					  :current-page="currentPage"
					  :page-sizes="[5, 10, 15, 20]"
					  :page-size="size"
					  layout="prev, pager, next"
					  :total="total"
					  @size-change="handleSizeChange"
      				  @current-change="handleCurrentChange">
					</el-pagination>
				  </div>
					
				</el-footer>
				

			
</div>
 </template>

 <script>
 
    export default {
     components: {
    
    },
    	data(){
    		return{  
                searchform:{
                    keyword:'',
                    time:[],
                    searchOptions:[
                
                    {
                    label:this.$i18n.t("nav.아이디"),
                    value:'mem_id'
                },
                {
                    label:this.$i18n.t("msg.알본"),
                    value:'admin_id'
                },
            

                ],
               
            
                value:'',
          


                },  
                otp:'',
          domain:window.sessionStorage.getItem('domain'),
           sitetype:window.sessionStorage.getItem('sitetype'),
           bg:window.sessionStorage.getItem('bg'),
           userid:window.sessionStorage.getItem('userid'),
            aid:window.sessionStorage.getItem('admin_id'),
    			formLoading:false,
          idDialogVisible: false,
    			total:0,
    			size:0,
    			loading: false,
    			tableData: [],
    			currentPage:1,
			    multipleSelection:[],
			   
   
    			}
	
    		},
    		created() {
    			this.getList();
               this.defaultDate()

		},
    	
    	methods:{
    		
        
    		 handleSizeChange(val) {
			        //console.log(`每页 ${val} 条`);
			        this.size = val
			        this.getList();
			        this.loading= true

			      },
           defaultDate() {
                  var date = new Date()
                  var year = date.getFullYear().toString()
                  var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString()
                  var da = date.getDate() < 10 ? '0' + date.getDate().toString() : date.getDate().toString()
                  // var da = new Date(date.getFullYear(), month, 0).getDate()
                  da < 10 ? '0' + da.toString() : da.toString()
                  var beg = year + '-' + month + '-01'
                  var end = year + '-' + month + '-' + da
                  this.searchform.time = [end, end] 
                },

			      handleCurrentChange(val) {
			        //console.log(`当前页: ${val}`);
			        this.currentPage = val
			        this.getList();
			        this.loading= true
			      },
                    searchEvent(){

                if(this.searchform.keyword!='' && this.searchform.value == ''){
                     this.$message(this.$i18n.t("msg.검색타이틀선택하세요"));
                     return;
                }

              
            


                this.getList();
                
             

            },
			     
    		getList(){

    		   let s_time="";
               let e_time="";

               if(this.searchform.time.length>0)
               {
                  s_time=this.searchform.time[0];
                  e_time=this.searchform.time[1];
               }
              
    			this.loading = true

    			 let token=window.sessionStorage.getItem('user');
    				//console.log(token);
    			 let urls=this.domain+'/user/dayrog?s_time='+s_time+'&e_time='+e_time+'&page='+this.currentPage;
    			
    		
    			this.$axios({
	                method:'get',
	                url:urls,
	                'Accept': 'application/json',
	                 headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 


                     console.log('dayrog=',response.data.data)
                     this.tableData =response.data.data
                
                     this.loading =false
               
            }).catch((error) =>{
            	

               this.$message.error(error);
              this.loading = false
                //console.log('error',error.response)       //请求失败返回的数据
               
            })
    		},
    		
    		
    		
    		
    	
    	  // 批量删除
			deleteAll(){
				 this.$confirm(this.$i18n.t("msg.삭제하시겠습니까"), this.$i18n.t("msg.알림"), {
          confirmButtonText: this.$i18n.t("msg.삭제"),
          cancelButtonText: this.$i18n.t("msg.취소"),
					type: 'warning'
				}).then(() => {
					let token=window.sessionStorage.getItem('user');

					//console.log('hh',this.multipleSelection);

                    let newids=[];

					 this.multipleSelection.forEach(item=>{
					 	
					 	console.log('id',item);
					 	newids.push(item.id);
					 });

					// console.log('newids',newids);

					this.$axios({
			                method:'post',
			                 data:{idx:newids,opt:this.otp},
			                url:this.domain+'/admin/logine_del',
			                'Accept': 'application/json',
			                headers: { 'Authorization': 'Bearer ' + token },
			                
			               
			            }).then((response) =>{ 
			            	
			            	if(response.data.code==200){
			            		this.$message({
					    				message:response.data.msg,
					    				type:'success'
			    					})
			            	}else
                    {
                        this.$message({
                         message:response.data.msg,
                          type:'error'
                        })
                    }
			            	this.getList()
    
			            }).catch((error) =>{
			                console.log(error)       //请求失败返回的数据
			            })
           				
       

    			})

				
			}, 	
    	
    		
    	}
  }
</script>

 <style scoped>
 /deep/ .el-form-item__content{
    display:flex;
    align-items:center;
    line-height:30px;
 }
 /deep/ .el-dialog{
    height:700px;overflow-y:scroll
 }
 /deep/ .el-input__inner{
  height:30px;
  line-height:30px;
 }
 /deep/ .el-form-item__label{
  line-height:30px;
 }
 /deep/ .el-dialog__body{
  padding:10px 20px
 }.el-picker-panel{
  z-index:12000 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/common/dayrog.vue